import { User } from '../../models/User'
import { UserState } from '../reducers/UserReducer'
import { GlobalState } from '../reducers'

export const getUser = (state: { user: UserState }): User => state.user.user


